module.exports = __webpack_public_path__ + "static/media/HealingTheInnerChild.43382ef4.jpg";